import React from 'react';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import Modal, { ModalButton } from '../../../ui/Modal';

const ApplicationsModalCancellation = ({ onClose, onConfirm }) => (
  <Modal
    isOpen={true}
    onClose={onClose}
    title="Отменить заявки"
    subtitle="Действие можно будет отменить только вручную."
    size="sm"
    footer={
      <>
        <ModalButton variant="ghost" onClick={onClose}>Не отменять</ModalButton>
        <ModalButton variant="danger" onClick={onConfirm}>
          <CancelOutlinedIcon sx={{ fontSize: 18 }} />
          Отменить заявки
        </ModalButton>
      </>
    }
  >
    <p style={{
      margin: 0, fontSize: 13.5, lineHeight: 1.55, color: '#6F6259',
    }}>
      Выбранные заявки будут переведены в статус «Отменён».
      Клиенты получат соответствующее уведомление.
    </p>
  </Modal>
);

export default ApplicationsModalCancellation;
